// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DL2z","left":"styles_left__3yjcJ"};